import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  parentBox: {
    flex: 1,
    position: 'relative',
    justifyContent: 'flex-start',
  },
  scannerContainer: {
    flex: 2.5,
    position: 'relative',
  },
  detailsContainer: {
    paddingHorizontal: 10,
    paddingVertical: 10,
    alignItems: 'flex-start',
  },
  textAlignLeft: {textAlign: 'left'},
  loadingBox: {
    alignSelf: 'center',
    justifyContent: 'center',
    paddingTop: 10,
  },
  bottomButton: {
    paddingHorizontal: 10,
    alignSelf: 'stretch',
    flex: 1,
  },
  buttonContainer: {
    flex: 1,
  },
  imageStyle: {
    width: 75,
    height: 75,
  },
  itemText: {
    flex: 0.5,
    flexGrow: 1,
    paddingRight: 2,
  },
  details: {width: '100%'},
  buttonsContainer: {paddingTop: 20, gap: 20},
  loadingComponent: {
    marginLeft: 5,
  },
  divider: {
    marginVertical: 10,
  },
  itemDetailsContainer: {
    gap: 10,
  },
  barcodeBox: {justifyContent: 'flex-start', gap: 5},
});
